<template>
	<div id="calc" class="calculator wrapper container-fluid" @click.stop.prevent="handleClick">
		<p class="txt--xl mb--2 mb-2">
				Predicts likelihood of asthma exacerbation within 6 months.
		</p>
    <p class="mb--2 mb-2">
				It is recommended that this calculator is used in conjunction with the <a data-id="3482" data-udi="umb://document/4a1d5b706ff841bf892cd2c81aef2821" href="/right-decision-toolkit-for-primary-care/asthma/asthma-control-questionnaire-5-questions-acq-5/" title="Asthma Control Questionnaire 5 (ACQ 5)">ACQ 5 Calculator</a>
		</p>
		<div class="tabs mb--2">
			<nav class="tabs__nav">
				<button v-for="(tab) in tabs" v-bind:key="tab.title" role="button" class="tabs__nav-item txt--strong" :class="{ 'tabs__nav-item--active bg--primary': tab.display }" v-on:click="selectTab(tab)">
					<span v-html="tab.title"></span>
					<i v-if="!tab.display" aria-hidden="true" class="fa fa-chevron-down ml-1 ml--1 show--md"></i>
					<i v-if="tab.display" aria-hidden="true" class="fa fa-chevron-up ml-1 ml--1 show--md"></i>	
				</button>
			</nav>
			<div class="tabs__content" id="tabcontent">
				<div v-for="(tab) in tabs" v-bind:key="tab.content">
					<div v-if="tab.display" class="bdr--light-gray p--1 wysiwyg" role="tabpanel" :aria-labelledby="tab.title" v-html="tab.content"></div>
				</div>
			</div>
		</div>

	<!--<div class="accordion bdr--light-gray accordion--arrows mb--2 hide--md">
			<div class="accordion__item bdr__top--light-gray" data-accordion-type="default" v-for="(tab, index) in tabs" v-bind:key="tab.title">
				<button :id="'tab'+index" class="accordion__header txt--md txt--strong" :class="{ 'accordion__header--active' : tab.accordion }" @click="tab.accordion = !tab.accordion">{{tab.title}}</button>
				<div :aria-labelledby="'tab'+index" class="accordion__content" :class="{ 'accordion__content--active active' : tab.accordion }" v-html="tab.content"></div>
			</div>
		</div>-->

		<div class="questions__intro-text">
			<div class="row">
				<div class="col-12 col-xs-12">
					<p>Click on the answer to each question below, then click on Calculate.</p>
				</div>
			</div>
		</div>
		<div class="row" v-for="q in questions" :key="q.id">
			<div class="col-12 col-xs-12 mb-1 mb--1">
				<div class="row" v-if='q.header != ""'>
					<div class="col-xs-12"><h2>{{q.header}}</h2></div>
				</div>
				<div class="row">
					<div class="col-12 col-xs-12 col-sm-6">
						<h3 class="txt--xl mb-1 mb--1">{{q.title}}</h3>
						<p v-html="q.info"></p>
					</div>
					<div class="col-12 col-xs-12 col-sm-6">
						<div class="list-group">
							<div v-for="o in q.options" :key="o.id">
								<button @click="optionclicked(q.id,o.id)"
										@keydown.enter="optionclicked(event, q.id,o.id)"
										type="button"
										v-bind:class="{'list-group-item list-group-item-action d-flex justify-content-between align-items-center active':(o.selected), 'list-group-item list-group-item-action d-flex justify-content-between align-items-center':(!o.selected)}">
									{{o.text}}
									<span class="badge badge-success badge-pill">{{o.value_label}}</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<hr class="mb-2 mb--2">
			</div>
		</div>
    <div id="error" class="row">
			<div class="col-12 col-xs-12">
				<div class="alert alert-info alert-informative alert--info mb-3 mb--3" role="alert" v-if="errormessage.length > 0" v-html="errormessage"></div>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-xs-12">
				<div class="calculator__result bg-secondary bg--secondary p--2 p-2 mb--2 mb-2">
					<div id="calculator-copy" class="color--white text-white mb-1 mb--1" v-if="displayresult">
						<div id="result-response" v-if="isvalid"></div>
						<p class="txt--xl h3" v-if="result.text.length > 0 && errormessage.length == 0"><strong>Recommendation:</strong> {{result.text}}</p>
						<h3 v-if="errormessage.length == 0"  class="h4 txt--lg"><strong>Total RSE Score</strong> : {{result.score}}</h3>
						<h3 v-if="errormessage.length > 0"  class="h4 txt--lg"><strong>Total RSE Score</strong> : N/A</h3>
						<p v-if="result.calctext.length > 0 && errormessage.length == 0" v-html="result.subtext"></p>
						<p v-if="result.calctext.length > 0" v-html="result.calctext"></p>
						<!-- -->
					</div>
					<div class="control-holder">
						<button class="btn mr-1 mr--1" @click="calculateclicked" type="button" v-if="!displayresult">Calculate</button>
						<button class="btn mr-1 mr--1" type="button" @click="reset" v-if="displayresult">Reset</button>
            <button class="btn mr-1 mr--1" id="copyButton" type="button" @click="copyToClipboard" v-if="displayresult">Copy Result</button>
						<button class="btn mr-1 mr--1 hide--quris" type="button" @click="displayForm" v-if="displayresult">Email PDF</button>
					</div>
				</div>
				<div class="bg--offwhite bg-offwhite p-2 p--2" v-if="displayresult && showform">
						<p class="color--black">For security reasons, this form is only available within the NHS network. You can use it to email to an NHS email a PDF with the decision support result for this patient and then save it to the patient record.</p>
						<div class="color--black alert alert-danger alert--error mb-1 mb--1" role="alert" v-if="emailmessage.length > 0" v-html="emailmessage"> </div>
						<div class="form__group mb--2">
							<label for="emailaddresses" class="form__label mb--1 txt--strong">Email addresses:</label>
							<input v-model="emailaddresses" type="text" class="form__input" name="emailaddresses" id="emailaddresses" placeholder="Enter email address(es) to receive this decision support output. NHS emails only">
						</div>
						<div class="form__group mb--2">
							<label for="patientname" class="form__label mb--1 txt--strong">Patient's Full Name:</label>
							<input v-model="patientname" type="text" class="form__input" name="patientname" id="patientname" placeholder="Enter patient’s full name">
						</div>
						<div class="form__group mb--2">
							<label for="patientchinumber" class="form__label mb--1 txt--strong">Patient CHI Number:</label>
							<input v-model="patientchinumber" type="text" class="form__input" name="patientchinumber" id="patientchinumber" placeholder="Enter patient’s CHI number">
						</div>
						<button class="btn mr-1 mr--1" type="button" @click="sendToPDF">Send</button>
					</div>
					<div class="alert alert-success alert--success mb-3 mb--3" role="alert" v-if="displayresult && !showform && emailmessage.length > 0 && emailaddresses.length > 0 && patientname.length > 0 && patientchinumber.length > 0" v-html="emailmessage"></div>
			</div>
		</div>
		<Content />
	</div>
</template>

<script>
	import Content from '@/components/Content';
	import "isomorphic-fetch";

	export default {
		name: "Calculator",
		components: {
			Content
		},
  data() {
    return {
      emailaddresses: "",
      patientname: "",
      patientchinumber: "",
      questions: [
        {
          id: "q1",
          title: "BMI >=30 kg/m2",
					header: "",
          required: false,
          info: "<strong>BMI</strong> = kg/m2 where kg is a person's weight in kilograms and m2 is their height in metres squared.",
          options: [
            {
              id: "o1",
              text: "No",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o2",
              text: "Yes",
              value_label: "+14",
              value: 14,
              selected: false
            },
          ]
        },
        {
          id: "q2",
          title: "Asthma Control Questionnaire 5",
					header: "",
          required: false,
          info: "",
          options: [
            {
              id: "o3",
              text: "<1.5",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o4",
              text: "1.5 - 2.5",
              value_label: "+7",
              value: 7,
              selected: false
            },
            {
              id: "o5",
              text: "> 2.5",
              value_label: "+13",
              value: 13,
              selected: false
            }           
          ]
        },
        {
          id: "q3",
          title: "Most recent postbronchodilator FEV1 (% Predicted normal value)",
					header: "",
          required: false,
          info: "Clinical judgement is required as to whether this most recently recorded FEV1 is appropriate or whether the patient needs to be invited to record a new FEV1.",
          options: [
            {
              id: "o6",
              text: "Over 90%",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o7",
              text: "Between 80% & 90%",
              value_label: "+13",
              value: 13,
              selected: false
            },
            {
              id: "o8",
              text: "Less than 80%",
              value_label: "+20",
              value: 20,
              selected: false
            }           
          ]
        },
        {
          id: "q4",
          title: "Rescue inhaler usage per day ",
					header: "",
          required: false,
          info: "",
          options: [
            {
              id: "o9",
              text: "< 2",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o10",
              text: "2 - 4",
              value_label: "+11",
              value: 11,
              selected: false
            },
            {
              id: "o11",
              text: "> 4",
              value_label: "+26",
              value: 26,
              selected: false
            }           
          ]
        },
        {
          id: "q5",
          title: "Global Initiative for Asthma (GINA) treatment step 4 or higher",
					header: "",
          required: false,
          info: "Medium-high inhaled steroid/long acting beta agonist",
          options: [
            {
              id: "o12",
              text: "No",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o13",
              text: "Yes",
              value_label: "+27",
              value: 27,
              selected: false
            },
          ]
        }
      ],
      result: {
        score: 0,
        calctext: "",
        text: "",
        subtext: ""
      },
      displayresult: false,
      showform: false,
      errormessage: "",
      emailmessage: "",
      isvalid: false,
      answered_count: 0,
			answer_acutechange: false,
			tabs: [
        {
          title: "When to use",
          display: false,
          accordion: false,
					content: `
						<p>Use in patients with poorly-controlled asthma to assist in guiding therapy and monitoring.</p>
					`,
        },
        {
          title: "Evidence",
          display: false,
          accordion: false,
					content: `
						<p>The RSE is based on a study by <strong>Bateman et al (2015): Development and validation of a novel risk score for asthma exacerbations: The risk score for exacerbations. Asthma and lower airway disease 135 (6): 1457-1464.</strong> <a href="https://doi.org/10.1016/j.jaci.2014.08.015" target="_blank">https://doi.org/10.1016/j.jaci.2014.08.015</a></p>
						<p>This study investigated predictors for failure to achieve good asthma control as defined by the <a href="https://ginasthma.org/" target="_blank">Global Initiative for Asthma (GINA)</a> and developed a simple risk score for exacerbations (RSE) for clinical use. It used a large data set from 3 studies to determine dominant predictors for uncontrolled asthma at 3 months and for severe asthma exacerbations within 12 months of commencing treatment.</p>
						<p>The RSE, right censored at 6 months to include all 3 studies, was based on the dominant predictors for exacerbations in two thirds of the data set and validated in one third.</p>
						<p>An exponential increase in risk of exacerbation was observed with increments in RSE based on 5 selected predictors based on simple routine clinical assessments.</p>
						<p>The authors noted that prospective validation of these predictive factors and the RSE is required. </p>
					`,
				},
        {
          title: "Calculation<span class='show--md'> & interpretation</span>",
          display: false,
          accordion: false,
					content: `
						<h4 class="txt--lg">Calculation</h4>
						<p>The RSE calculation is addition of assigned points for 5 criteria as indicated in the table below.</p>
						<table class="tbl table">
							<tr>
								<th width="45%">Name</th>
								<th width="35%">Input value</th>
								<th width="20%" align="right">Score</th>
							</tr>
							<tr>
								<td>BMI >=30 kg/m2</td>
                <td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>No</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>Yes</td>
                      <td align="right">+14</td>
                    </tr>
                  </table>
								</td>
							</tr>
							<tr>
								<td>Asthma Control Questionnaire 5</td>                
                <td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td><1.5</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>1.5-2.5</td>
                      <td align="right">+7</td>
                    </tr>
                    <tr>
                      <td>>2.5</td>
                      <td align="right">+13</td>
                    </tr>
                  </table>
								</td>
							</tr>
							<tr>
								<td>Most recent postbronchodilator FEV1 (% Predicted normal value) </td>                            
                <td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>>90%</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>>80%-90%</td>
                      <td align="right">+13</td>
                    </tr>
                    <tr>
                      <td><80%</td>
                      <td align="right">+20</td>
                    </tr>
                  </table>
								</td>
							</tr>
							<tr>
								<td>Rescue inhaler usage per day</td>
                <td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td><2</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>2-4</td>
                      <td align="right">+11</td>
                    </tr>
                    <tr>
                      <td>>4</td>
                      <td align="right">+26</td>
                    </tr>
                  </table>
								</td>
							</tr>
							<tr>
								<td>
									Global Initiative for Asthma (GINA) treatment step 4 or higher
									<br>
									Medium-high inhaled steroid/long acting beta agonist
								</td>
                <td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>No</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>Yes</td>
                      <td align="right">+27</td>
                    </tr>
                  </table>
								</td>
							</tr>
						</table>
						<h4 class="txt--xl">Interpretation of RSE scores</h4>
						<table class="tbl table">
							<tr>
								<th width="20%">RSE Score</th>
								<th width="80%">Likelihood of exacerbation in 6 months</th>
							</tr>
							<tr>
								<td>0-10</td>
								<td>5%</td>
							</tr>
							<tr>
								<td>11-20</td>
								<td>5-7%</td>
							</tr>
							<tr>
								<td>21-30</td>
								<td>7-10%</td>
							</tr>
							<tr>
								<td>31-40</td>
								<td>10-12%</td>
							</tr>
							<tr>
								<td>41-50</td>
								<td>12-15%</td>
							</tr>
							<tr>
								<td>51-60</td>
								<td>15-18%</td>
							</tr>
							<tr>
								<td>61-70</td>
								<td>18-24%</td>
							</tr>
							<tr>
								<td>71-80</td>
								<td>24-30%</td>
							</tr>
							<tr>
								<td>81-90</td>
								<td>30-37%</td>
							</tr>
							<tr>
								<td>91-100</td>
								<td>37-45%</td>
							</tr>
						</table>
					`,
        },
        {
          title: "Practice<span class='show--md'> considerations</span>",
          display: false,
          accordion: false,
					content: `
						<p>In applying the RSE in practice, clinicians should be aware of the following limitations:</p>
						<ul>
							<li>The RSE should be further studied - while the original study involved a large dataset, it was not validated outside of its own derivation cohort. It is also based on retrospective data analysis, and prospective studies are required.</li>
							<li>It was developed from pharmaceutical trials of patients with poorly controlled asthma, so it may not be applicable to patients with milder asthma severity.</li>
						</ul>
					`,
        }
      ]
    };
  },
  methods: {           
    handleClick(e) {
			if (e.target.matches("a")) {
				let url = e.target.href;
				let target = e.target.target == "_blank" ? "_blank" : "_self";
				let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
				var isnativeapp = document.getElementById("isnativeapp");
				if (isnativeapp === undefined || isnativeapp === null) 
				{
					window.open(url,target);  
				}
				else{
					if(target == "_blank") {
						let data = {title:'',nodeid: dataId, href:url, target: target};
						window.Native('dataCallback', data);
					} 
				}	
			}
		},
		selectTab(selectedTab) {
			this.tabs.forEach(tab => {
				if(tab.display) {
					tab.display = false;
				} else {
					tab.display = (tab.title == selectedTab.title);
				}
			});
		},
		displayForm(){		
      this.showform = !this.showform;
		},
    reset() {
      this.emailaddresses = "";
      this.patientname = "";
      this.patientchinumber = "";
      this.result.score = 0;
      this.result.calctext = "";
      this.result.text = "";
      this.displayresult = false;
      this.showform = false;
      this.errormessage= "";
      this.emailmessage = "";
      this.isvalid= false;
      this.answered_count= 0;
      this.answer_acutechange= false;
      this.questions.forEach(q => {
        q.options.forEach(o => {
            o.selected = false;
          });
      });
    },
    calculateclicked() {
			this.emailmessage	= "";
      this.emailaddresses = "";
      this.patientname = "";
      this.patientchinumber = "";
      this.showform = false;
			this.displayresult = true;
      if (this.answered_count < this.questions.length) {
        this.errormessage =	"<h2 class='txt--lg'>One or more inputs missing. </h2>";
				this.errormessage += "<p>Total RSE score cannot be calculated as one or more inputs are  missing. </p>";
				this.errormessage += "<p>Required inputs are: BMI >=30 kg/m2, Asthma Control Questionnaire 5, Most recent postbronchodilator FEV1, Rescue inhaler usage per day, Global Initiative for Asthma (GINA). </p>";
				setTimeout(()=> {
					document.getElementById("error").scrollIntoView(true)},100);
      } else {
        this.errormessage = "";
      }
		},
    copyToClipboard() {
      var range;
      var finalText = "";
      if (document.selection) { // IE
        range = document.body.createTextRange();
        range.moveToElementText(document.getElementById('calculator-copy'));
        range.select();
        finalText = this.getDateToday() + "\n\nRisk Score for Asthma Exacerbation (RSE)\n\n" + range + "\nEnter action taken as a result of this alert";
        document.selection.empty();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(document.getElementById('calculator-copy'));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        finalText = this.getDateToday() + "\n\nRisk Score for Asthma Exacerbation (RSE)\n\n" + window.getSelection().toString() + "Enter action taken as a result of this alert";
        window.getSelection().removeAllRanges();
      }
      var dummy = document.createElement("textarea");
      // Add it to the document
      document.body.appendChild(dummy);

      // Set its ID
      dummy.setAttribute("id", "dummy_id");

      // Output the array into it
      document.getElementById("dummy_id").value = finalText;

      // Select it
      dummy.select();

      // Copy its contents
      document.execCommand("copy");

      // Remove it as its not needed anymore
      document.body.removeChild(dummy);

      var clicked = false;
      var copyButton = document.getElementById('copyButton');
      if (!clicked) {
            var last = copyButton.innerHTML;
            copyButton.innerHTML = 'Copied!';
            clicked = true;
            setTimeout(function () {
                copyButton.innerHTML = last;
                clicked = false;
            }.bind(copyButton), 3000);
        }
    },
    getDateToday() {
      var date = "";
      var today = new Date();
      date = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + " " + (today.getHours() < 10 ? "0" + today.getHours() : today.getHours()) + ":" + (today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes());
      return date;
    },
    sendToPDF() {
        if (this.emailaddresses == "") {
            this.emailmessage = "You must supply at least one email address.";
        }
        else if (this.patientname == "") {
            this.emailmessage = "You must supply the patient's name.";
        }
        else if (this.patientchinumber == "") {
            this.emailmessage = "You must supply the patient CHI number."
        }
        else {
            var formToPost = {
                EmailAddresses: this.emailaddresses,
                PatientName: this.patientname,
                PatientChiNumber: this.patientchinumber,
                Questions: this.questions,
                Result: this.result,
                DisplayWarning: this.answered_count < this.questions.length,
            };

            var model = JSON.stringify(formToPost);

            fetch("/Asthma/GetRSEPDF", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: model
            })
                .then(response => response.text())
                .then(data => {
                    if (data.startsWith("Email Error: ")) {
                        this.emailmessage = data.replace("Email Error: ", "");
                        this.showform = true;
                    } else {
                        this.emailmessage = data;
                        this.showform = false;
                    }
                })
                .catch((error) => {
                    console.log('EMAIL ERROR', error);
                });
        }
    },
		anchorLink(i) {
			var element = document.getElementById(i);
			element.scrollIntoView();
			// console.log(element);
			// console.log(top);
			// window.scrollTo(0, top);
		},
		
    closedclicked() {
      this.displayresult = false;
    },
    optionclicked(qid, oid) {      
      this.displayresult = false;
      let _score = 0;
      this.questions.forEach(q => {
        if (q.id === qid) {
          q.options.forEach(o => {
            if (o.id === oid) {
              if(o.selected)
              {
                o.selected = false;
              }
              else
              {
                o.selected = true;
              }
              
            } else {
              o.selected = false;
            }
          });
        }
      });
      let _cnt = 0;
      let _required_cnt = 0;
      let _required_answered_cnt = 0;
      this.answer_acutechange = false;
      this.questions.forEach(q => {
        if (q.required) {
          _required_cnt++;
        }
      });
      this.questions.forEach(q => {
        q.options.forEach(o => {
          if (o.selected) {
            _score += o.value;
            _cnt++;
          }
          if (o.selected && q.required) {
            _required_answered_cnt++;
          }
          // if (q.id === "q4") {
          //   if (o.selected) {
          //     this.answer_acutechange = true;
          //   }
          // }
        });
      });

      this.answered_count = _cnt;
      this.isvalid = _required_answered_cnt === _required_cnt ;
      if (this.isvalid) {
        this.errormessage = "";
      }
      this.result.score = _score;

      if (_score <= 100) {
        this.result.text = "37-45% likelihood of exacerbation within 6 months.";
				this.result.subtext = "For an RSE score of 91-100, there is a 37-45% likelihood of exacerbation within 6 months. Refer to guidance below to support shared decision making on treatment options.<br><br>Clinicians should also refer to local guidance where appropriate.";
      }
      if (_score <= 90) {
        this.result.text = "30-37% likelihood of exacerbation within 6 months.";
				this.result.subtext = "For an RSE score of 81-90, there is a 30-37% likelihood of exacerbation within 6 months. Refer to guidance below to support shared decision making on treatment options.<br><br>Clinicians should also refer to local guidance where appropriate.";
      }
      if (_score <= 80) {
        this.result.text = "24-30% likelihood of exacerbation within 6 months.";
				this.result.subtext = "For an RSE score of 71-80, there is a 24-30% likelihood of exacerbation within 6 months. Refer to guidance below to support shared decision making on treatment options.<br><br>Clinicians should also refer to local guidance where appropriate.";
      }
      if (_score <= 70) {
        this.result.text = "18-24% likelihood of exacerbation within 6 months.";
				this.result.subtext = "For an RSE score of 61-70, there is a 18-24% likelihood of exacerbation within 6 months. Refer to guidance below to support shared decision making on treatment options.<br><br>Clinicians should also refer to local guidance where appropriate.";
      }
      if (_score <= 60) {
        this.result.text = "15-18% likelihood of exacerbation within 6 months.";
				this.result.subtext = "For an RSE score of 51-60, there is a 15-18% likelihood of exacerbation within 6 months. Refer to guidance below to support shared decision making on treatment options.<br><br>Clinicians should also refer to local guidance where appropriate.";
      }
      if (_score <= 50) {
        this.result.text = "12-15% likelihood of exacerbation within 6 months.";
				this.result.subtext = "For an RSE score of 41-50, there is a 12-15% likelihood of exacerbation within 6 months. Refer to guidance below to support shared decision making on treatment options.<br><br>Clinicians should also refer to local guidance where appropriate.";
      }
      if (_score <= 40) {
        this.result.text = "10-12% likelihood of exacerbation within 6 months.";
				this.result.subtext = "For an RSE score of 31-40, there is a 10-12% likelihood of exacerbation within 6 months. Refer to guidance below to support shared decision making on treatment options.<br><br>Clinicians should also refer to local guidance where appropriate.";
      }
      if (_score <= 30) {
        this.result.text = "7-10% likelihood of exacerbation within 6 months.";
				this.result.subtext = "For an RSE score of 21-30, there is a 7-10% likelihood of exacerbation within 6 months. Refer to guidance below to support shared decision making on treatment options.<br><br>Clinicians should also refer to local guidance where appropriate.";
      }
      if (_score <= 20) {
        this.result.text = "5-7% likelihood of exacerbation within 6 months.";
				this.result.subtext = "For an RSE score of 11-20, there is a 5-7% likelihood of exacerbation within 6 months. Refer to guidance below to support shared decision making on treatment options.<br><br>Clinicians should also refer to local guidance where appropriate.";
			}
      if (_score <= 10) {
        this.result.text = "5% likelihood of exacerbation within 6 months.";
				this.result.subtext = "For an RSE score of 0-10, there is a 5% likelihood of exacerbation within 6 months. Refer to guidance below to support shared decision making on treatment options.<br><br>Clinicians should also refer to local guidance where appropriate.";
      }

      let _calctext = "";
      let _idx2 = 0;
      //let _len = this.questions.length;
      this.questions.forEach(q => {
        //_calctext = _calctext + q.title+": ";

        q.options.forEach(o => {
          if (o.selected) {
            if (_idx2 === 0) {
							_calctext = _calctext + "<strong>" + q.title + "</strong><br><span class='badge badge-success badge-pill'>"+ o.value_label + "</span>&nbsp;"+ o.text +"<br><br>";
            } else {
							_calctext = _calctext + "<strong>" + q.title + "</strong><br><span class='badge badge-success badge-pill'>"+ o.value_label + "</span>&nbsp;"+ o.text +"<br><br>";
            } 
          }
				});
				

        _idx2++;
      });
      
      this.result.calctext = _calctext;
    }
  }
};
</script>